module.exports = __webpack_public_path__ + "static/media/close-white.19b8d353.svg";